module.exports = __webpack_public_path__ + "img/mit-mat-3.9f586987.png";